import { useEffect } from 'react';
import { useNavigationComponentReceiver, useComponentsScheduler } from '../../hooks/internal';
import { useNativeCapabilities } from '../../hooks/internal/useNativeCapabilities';
import { useNavComponentsManager } from '../../hooks/useNavComponentsManager';
import { RenderNavComponent } from './RenderNavComponent';
import { ErrorBoundary } from '../../../common/components';
import { Logger } from 'simple-logging-lib';
import { PLATFORM_LOGGER } from '../../../config';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getInstantlyLoadedComponents = config => Object.entries(config).reduce((components, [name, {
  deferLoading = true
}]) => {
  if (!deferLoading) {
    components.add(name);
  }
  return components;
}, new Set());
export const RenderAllNavComponents = ({
  enableScheduler
}) => {
  useNativeCapabilities();
  useNavigationComponentReceiver();
  const {
    config,
    setComponentState
  } = useNavComponentsManager();
  const scheduler = useComponentsScheduler();
  useEffect(() => {
    if (!enableScheduler) {
      return;
    }
    const components = getInstantlyLoadedComponents(config);

    /* Schedule loading of all components rather than diff because we don't know
     at what point previous run was cancelled. This is fine because we don't
     actually apply state changes if they result in no changes */
    components.forEach(name => {
      scheduler.enqueue(() => {
        setComponentState(name, state => Object.assign({}, state, {
          isLoaded: true
        }));
      });
    });
  }, [config, scheduler, setComponentState, enableScheduler]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.entries(config).map(([name, definition]) => /*#__PURE__*/_jsx(ErrorBoundary, {
      name: `RenderNavComponent-${name}`,
      logger: Logger.getLogger(PLATFORM_LOGGER),
      children: /*#__PURE__*/_jsx(RenderNavComponent, Object.assign({}, definition))
    }, name))
  });
};